export enum ShortsContentType {
  ARTICLE = "Article",
  VIDEO = "Video"
}

export interface BaseShortsFeedItem {
  id: string | number;
  type: string;
  title: string;
  description: string;
  sourceUrl: string;
  thumbnail: string;
  publishedAt: string;
  author: string | null;
  category: string | null;
  tags?: string[];
}

export interface ArticleShortsFeedItem extends BaseShortsFeedItem {
  type: "Article";
  source: "strapi";
}

export interface VideoShortsFeedItem extends BaseShortsFeedItem {
  type: "Video";
  source: "youtube";
}

export type ShortsFeedItemData = ArticleShortsFeedItem | VideoShortsFeedItem;

export interface ShortsFeedProps {
  className?: string;
}
